import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {TestimonialService} from '../../shared/services/testimonial.service';
import {AuthenticationService} from '../../shared/services/authentication.service';
import {CompanyService} from '../../shared/services/company.service';
import {group_by_item_count} from '../../functions';
import {EventService} from '../../shared/services/event.service';
import {VideoService} from '../../shared/services/video.service';
import {ExternalpageService} from '../../shared/services/externalpage.service';
import {LocaleService} from '../../shared/services/locale.service';

@Component({
    selector: 'app-page-i-am-a-company',
    templateUrl: './page-i-am-a-company.component.html',
    styleUrls: ['./page-i-am-a-company.component.scss'],
    standalone: false
})
export class PageIAmACompanyComponent implements OnInit {

  companies: any = [];

  public companySlider = {
    slides_desktop: [],
    slides_mobile: []
  }

  eventSlider = {
    slides_desktop: <any> [],
    slides_mobile: <any> []
  };

  testimonialSlider = {
    slides :<any> []
  };

  events: any[] = [];

  /**
   * Constructor
   *
   * @param translate
   * @param authService
   * @param companyService
   * @param testimonialService
   */
  constructor(public translate: TranslateService,
              public authService: AuthenticationService,
              public companyService: CompanyService,
              public videoService: VideoService,
              public eventService: EventService,
              public testimonialService: TestimonialService,
              public externalpageService: ExternalpageService,
              public locale: LocaleService
  ) { }

  ngOnInit(): void {

    this.eventService.setHomeData();
    this.testimonialService.setHomeData();
    this.companyService.setHomeData();


    // Load home events data
    this.events = this.eventService.homeData;
    if (this.events.length == 0) {
      this.eventService.$homeDataSubject.subscribe( (value) => {
        this.events = this.eventService.homeData;
        this.eventSlider.slides_desktop = group_by_item_count(this.events, 3);
        this.eventSlider.slides_mobile =  group_by_item_count(this.events, 1);
      });
    } else {
      this.eventSlider.slides_desktop = group_by_item_count(this.events, 3);
      this.eventSlider.slides_mobile =  group_by_item_count(this.events, 1);
    }

    this.eventSlider.slides_desktop = group_by_item_count(this.events, 3);
    this.eventSlider.slides_mobile =  group_by_item_count(this.events, 1);


    // Load home company data
    this.companies = this.companyService.homeData;
    if (this.companies.length == 0) {
      this.companyService.$homeDataSubject.subscribe( (value) => {
        this.companies = this.companyService.homeData;
        this.companySlider.slides_desktop = group_by_item_count(this.companies, 10);
        this.companySlider.slides_mobile =  group_by_item_count(this.companies, 2);
      });
    } else {
      this.companySlider.slides_desktop = group_by_item_count(this.companies, 10);
      this.companySlider.slides_mobile =  group_by_item_count(this.companies, 2);
    }

    // Load home testimonial data
    this.testimonialSlider.slides = this.testimonialService.homeData;
    if (this.testimonialSlider.slides.length == 0) {
      this.testimonialService.$homeDataSubject.subscribe( (value) => {
        this.testimonialSlider.slides = this.testimonialService.homeData;
      });
    } else {
      this.testimonialSlider.slides = this.testimonialService.homeData;
    }

  }


}
